<template>
    <b-modal v-model="visible" centered no-close-on-backdrop>
        <template #modal-header="{ close }">
            <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                <b-col cols="10" class="text-left">
                    <h6>{{ $t('FactorStates') }}</h6>
                </b-col>
                <b-col cols="2" class=" pr-0 p-1 pl-4 text-right">
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close();" v-b-tooltip.hover :title="$t('Cancel')" /> <!-- Fermer -->
                </b-col>
            </b-row>
        </template>

        <!-- mode automatique + selection en adéquation -->
        <b-row align-v="center">
            <b-col cols="1">
                <!-- Icone fontawesome en plusieurs couches (/!\ l'ordre est important) -->
                <font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'circle']" size="2x" class="text-gray" transform="grow-2" /> <!-- Fond indication 'bouton' désactivé -->
                    <font-awesome-icon :icon="['far', 'circle']" size="2x" /> <!-- Cercle -->
                    <font-awesome-icon icon="a" size="1x" transform="right-8" /> <!-- Lettre indication mode 'Auto' -->
                </font-awesome-layers>
            </b-col>
            <b-col>
                {{ $t('AutomaticSelectionInLineCalc') }} <!-- Sélection automatique en adéquation avec la sélection de l'arborescence pour le calcul. --> 
            </b-col>
        </b-row>

        <hr class="py-1" />

        <!-- mode manuel + selection en adéquation -->
        <b-row align-v="center">
            <b-col cols="1">
                <!-- Icone fontawesome en plusieurs couches (/!\ l'ordre est important) -->
                <font-awesome-layers>
                    <font-awesome-icon icon="slash" size="2x" transform="shrink-6 left-2 flip-v"/> <!-- Barre indication mode manuel -->
                    <font-awesome-icon :icon="['far', 'circle']" size="2x" /> <!-- Cercle -->
                    <font-awesome-icon icon="a" size="1x" transform="right-8" /> <!-- Lettre indication mode 'Auto' -->
                </font-awesome-layers>
            </b-col>
            <b-col>
                {{ $t('ManualSelectionCalc') }} <!-- Sélection manuelle pour le calcul. -->
            </b-col>
        </b-row>

        <hr class="py-1" />

        <!-- mode automatique + selection non en adéquation -->
        <b-row align-v="center">
            <b-col cols="1">
                <!-- Icone fontawesome en plusieurs couches (/!\ l'ordre est important) -->
                <font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'circle']" size="2x" class="text-gray" transform="grow-2" /> <!-- Fond indication 'bouton' désactivé -->
                    <font-awesome-icon :icon="['far', 'circle']" size="2x" class="text-warning" /> <!-- Cercle indicatif mode erreur -->
                    <font-awesome-icon icon="a" size="1x" transform="right-8" /> <!-- Lettre indication mode 'Auto' -->
                </font-awesome-layers>
            </b-col>
            <b-col>
                {{ $t('AutomaticSelectionNotInLineCalc') }} <!-- Sélection automatique non en adéquation avec la sélection de l'arborescence pour le calcul. -->
            </b-col>
        </b-row>

        <hr class="py-1" />

        <!-- mode manuel + selection non en adéquation (cas benchmarking) -->
        <b-row align-v="center">
            <b-col cols="1">
                <!-- Icone fontawesome en plusieurs couches (/!\ l'ordre est important) -->
                <font-awesome-layers> 
                    <font-awesome-icon icon="slash" size="2x" transform="shrink-6 left-2 flip-v" class="text-warning"/> <!-- Barre indication mode manuel -->
                    <font-awesome-icon :icon="['far', 'circle']" size="2x" class="text-warning" /> <!-- Cercle indicatif mode erreur -->
                    <font-awesome-icon icon="a" size="1x" transform="right-8" /> <!-- Lettre indication mode 'Auto' -->
                </font-awesome-layers>
            </b-col>
            <b-col>
                {{ $t('ManualSelectionInLineCalc') }} <!-- Aggrégation de sélections manuelles comportant des éléments non en adéquation avec la sélection de l'arborescence pour le calcul -->
            </b-col>
        </b-row>

        <template #modal-footer="{ close }">
            <b-button pill :variant="'outline-' + Variant" @click="close();">{{ $t('Close') }} <!--Annuler--></b-button>
        </template>
    </b-modal>
</template>

<script lang="ts">
    import { Prop, PropSync, Vue } from 'vue-property-decorator';
    import Component from 'vue-class-component';

    /** Traductions */
    import locales from "../locales/FactorStates.json";

    @Component({
        i18n : { messages : locales }
    })
    export default class FactorStates extends Vue {
        /** Variant de couleur à appliquer sur le composant */
        @Prop({ default: () => "secondary"})
        public Variant!: string;

        @PropSync("Visible")
        public visible!: boolean;
    }
</script>

<style scoped>
</style>